$(function() {
    $(document).foundation();
});